<template>
  <div class="orders-page">
    <div class="order-modal__head">
      <div class="order-modal__title mb10">
        <span v-if="!isNew">{{$t('modals.details')}}</span>
        <span v-else>{{$t('forms.thankUTitle')}}</span>
        <button @click="close" class="order-modal__address-close">
          <img src="@/assets/images//close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="order-modal__body d-flex">
      <div class="order-modal__left">
        <img class="order-modal__image" :src="getImage(order)" alt="master" />
      </div>
      <div class="order-modal__right">
        <div class="d-m-flex">
          <div class="order-modal__box">
            <div class="order-modal__cta mb16" @click="doAction(order.status)">
              <orders-btn
                class="order-item__info order-item__status"
                :class="`order-item__status_${order.status}`"
                :status="order.status"
                :list="false"
              />
            </div>

            <p class="order-item__info mb16 order-item__flex">
              <img src="@/assets/images/clock-2.svg" width="24px" alt />
              <span>{{formatOrderDate(order.should_started_at)}}</span>
            </p>

            <p class="order-item__info mb16 order-item__flex">
              <img src="@/assets/images/map-pin.svg" width="24px" alt />
              <span>
                {{order.address.street}}
                {{order.address.house}},
                {{order.address.postcode || '00001'}},
                {{order.address.city}}
              </span>
            </p>
          </div>
        </div>

        <div class="order-item__info order-item__flex mb16">
          <p class="order-item__info order-item__info_service order-item__flex">
            <img :src="order.service.icon" width="24px" alt />
            {{order.service.title}}
          </p>
          <p class="order-item__info order-item__info_mml20 order-item__flex">
            <img src="@/assets/images/money.svg" width="24px" alt />
            <span>{{printPrice(order.total_price)}}</span>
          </p>
        </div>

        <div v-if="order.description" class="mt10">
          <p class="order-modal__master-desc">{{order.description}}</p>
        </div>

        <div class="mt24 mb10" v-if="order.executors[0] != undefined">
          <p>{{order.executors[0].first_name}} {{order.executors[0].last_name}}</p>
        </div>

        <div
          class="order-item__info order-item__flex mb24"
          v-if="order.executors[0] != undefined && order.executors[0].description"
        >
          <p class="order-modal__master-desc">{{ order.executors[0].description }}</p>
        </div>

        <div class="order-media mt10" v-if="order.media && order.media.length > 0">
          <p>Media</p>

          <div class="order-media__box">
            <img :src="item.original" alt v-for="item in order.media" :key="item.original" />
          </div>
        </div>

        <div class="order-files mt10" v-if="orderFiles && orderFiles.length > 0">
          <p>Files</p>

          <p v-for="item in orderFiles" :key="item.name">
            <a class="order-files__link" target="_blank" :href="item.file_path">{{item.name}}</a>
          </p>
        </div>

        <div v-if="masterRate.length > 0" class="mt10">
          <div>
            <p>Your rate:</p>
          </div>
          <div class="mt10">
            <svg
              v-for="item in masterRate"
              :key="item.id"
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              :class="{
                                'rate-star_active': item.isPainted
                            }"
              ref="rate-master-1"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>
          <div class="mt10">
            <svg
              v-for="item in serviceRate"
              :key="item.id"
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              :class="{
                                'rate-star_active': item.isPainted
                            }"
              ref="rate-master-1"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>
          <div class="mt10" v-if="order.rating.comment">
            <p class="order-modal__master-desc">{{order.rating.comment}}</p>
          </div>
        </div>

        <div class="mt24" style="display:flex" v-if="canUpdate">
          <button
            class="btn btn_primary btn_foz12 btn_h40 btn_shadow-none mr10"
            @click="openCommentAndFilesModal"
          >+ photo</button>
          <button
            class="btn btn_primary btn_foz12 btn_h40 btn_shadow-none ml10"
            @click="openEditModal"
          >edit info</button>
        </div>
      </div>
      <div class="order-modal__footer" v-if="isNew">
        <p>{{$t('forms.thankUText')}}</p>
      </div>
    </div>

    <main-modal :show="isShowEditOrder" :className="'edit-order-modal'" @close="closeEditModal">
      <edit-order-modal
        :contact="order.contact"
        :date="order.should_started_at"
        :id="order.id"
        :service_id="order.service.id"
        :status="order.status"
        @onSave="onSavedOrderInfo"
        @onCanceled="onCanceled"
        @close="closeEditModal"
      />
    </main-modal>

    <main-modal
      :show="isShowEditAndComment"
      :className="'edit-comment-and-files-modal'"
      @close="closeCommentAndFilesModal"
    >
      <edit-comment-and-files-modal
        :id="order.id"
        :description="order.description"
        @onSave="onSavedCommentAndFiles"
        @close="closeCommentAndFilesModal"
      />
    </main-modal>
  </div>
</template>

<script>
import dateMixin from "@/mixins/date";
import { mapMutations, mapActions, mapGetters } from "vuex";
import ordersBtn from "@/components/buttons/orders/index";
import printPrice from "@/mixins/price/printPrice";

import mainModal from "@/components/modals/mainModal";
import deleteModal from "@/components/modals/delete/index";
import editOrderModal from "@/components/modals/orders/editOrderModal";
import editCommentAndFilesModal from "@/components/modals/orders/editCommentAndFilesModal";
import orders from "@/mixins/orders";

export default {
  props: {
    order: {
      required: true,
      type: Object
    }
  },
  mixins: [dateMixin, printPrice, orders],
  components: {
    ordersBtn,
    mainModal,
    deleteModal,
    editOrderModal,
    editCommentAndFilesModal
  },
  data() {
    return {
      defaultImage: "/images/weWillCall.svg",
      serviceRate: [],
      masterRate: [],

      isShowEditOrder: false
    };
  },
  computed: {
    canUpdate() {
      return (
        this.order.status === "new" ||
        this.order.status === "stand_by" ||
        this.order.status === "confirmed"
      );
    },
    ...mapGetters({
      orderFiles: "orders/files",
      isShowEditAndComment: "orders/isShowEditAndComment"
    }),
    isNew() {
      return this.order.status === "new" || this.order.status === "stand_by";
    }
  },
  methods: {
    ...mapMutations({
      setState: "main/setState",
      setIsComponent: "orders/setIsComponent",
      setStateOrder: "orders/setState"
    }),
    ...mapActions({
      fetchById: "orders/fetchById",
      update: "orders/update",
      fetchFiles: "orders/fetchFiles"
    }),
    async onCanceled() {
      this.closeEditModal();
      this.$emit("fetch");
      this.close();
    },
    openCommentAndFilesModal() {
      this.setStateOrder({
        key: "isShowEditAndComment",
        value: true
      });
    },
    closeCommentAndFilesModal() {
      this.setStateOrder({
        key: "isShowEditAndComment",
        value: false
      });
    },
    openEditModal() {
      this.isShowEditOrder = true;
    },
    closeEditModal() {
      this.isShowEditOrder = false;
    },
    async onSavedCommentAndFiles() {
      await this.fetchById(this.order.id);
      await this.fetchFiles(this.order.id);
      this.closeCommentAndFilesModal();
    },
    async onSavedOrderInfo() {
      await this.fetchById(this.order.id);
      this.closeEditModal();
    },
    getImage(item) {
      if (item == null) {
        return;
      }

      if (item.executors[0] && item.executors[0].big_image != null) {
        return item.executors[0].big_image;
      }

      return this.defaultImage;
    },
    async doAction(status) {
      console.log(status);
      if (status == "rating_review" || status == "payment") {
        this.close();
        this.setIsComponent(status);

        const response = await this.fetchById(this.order.id);
        this.setState({
          key: "mainModal",
          value: true
        });
      } else if (status === "job_finished") {
        await this.update({
          id: this.order.id,
          form: {
            status: "payment"
          }
        });

        await this.fetchOrdersMixin();
        this.close();
      }
    },
    close() {
      this.setState({
        key: "mainModal",
        value: false
      });
    },
    hasRate() {
      return this.order.rating != null;
    },
    prepareRate() {
      if (!this.hasRate()) {
        return;
      }

      this.prepareMasterRate();
      this.prepareServiceRate();
    },
    prepareMasterRate() {
      const rate = this.order.rating.master_rating;

      for (let i = 1; i <= 5; i++) {
        this.masterRate.push({
          id: i,
          isPainted: i <= rate
        });
      }
    },
    prepareServiceRate() {
      const rate = this.order.rating.company_rating;

      for (let i = 1; i <= 5; i++) {
        this.serviceRate.push({
          id: i,
          isPainted: i <= rate
        });
      }
    }
  },
  mounted() {
    this.prepareRate();
  }
};
</script>

<style lang="scss">
.order-modal {
  overflow-y: scroll;
  height: 100%;

  &_mh80 {
    max-height: 80vh;
  }

  &__title {
    font-style: normal;
    font-size: 34px;
    line-height: 110%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #000;
    font-family: "crossten";
    color: #fff;
  }

  &__address-close {
    background: transparent;
    border: none;
    position: absolute;
    right: 0;
    padding: 0;
    outline: none;
    cursor: pointer;
    display: flex;
    height: 24px;
    align-items: center;
    top: 0;
  }

  &__body {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    overflow: hidden;
    flex-wrap: wrap;
  }

  &__left {
    width: 45%;
    padding: 30px;
  }

  &__right {
    width: 55%;
    padding: 30px 30px 30px 0;
    position: relative;
    display: block;
  }

  &__footer {
    width: 100%;
    padding: 0 20px 20px 20px;
  }

  &__image {
    width: 240px;
    height: 289px;
    object-fit: cover;
    border-radius: 10px;

    &_small {
      width: 100px;
      height: 105px;
      object-fit: cover;
      margin-bottom: 30px;
      display: inline-block;
      margin-right: 20px;
    }
  }

  &__master-desc {
    width: 100%;
    font-size: 14px;
    line-height: 120%;
    padding: 12px;
    letter-spacing: 0.02em;
    color: #828282;
    border-radius: 10px;
    background-color: #f2f2f2;
    word-break: break-all;
  }

  &__master-name {
    color: #0c0c0c;
    font-size: 20px;
    line-height: 21px;
  }

  &__cta {
    position: absolute !important;
    right: 22px;
    top: 31px;
    max-width: 152px;
    z-index: 4;
  }

  &__info {
    display: flex;

    &_center {
      justify-content: center;
    }
  }
}

.order-media__box {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;

  img {
    width: calc(33% - 20px);
    height: 80px;
    display: block;
    margin: 10px;
    object-fit: cover;
  }
}

.order-files {
  word-break: break-all;

  &__link {
    color: #2c3e50;
    display: block;
    margin: 0 0 8px 0;
  }
}

@media (max-width: 768px) {
  .order-modal__cta {
    top: 35px;
  }

  .order-modal {
    &__left {
      width: 100%;
    }

    &__right {
      width: 100%;
    }
  }
}

@media (max-width: 600px) {
  .order-modal {
    &__left {
      padding-bottom: 0;
      display: flex;
      justify-content: center;
    }
    // &__box {
    //     height: auto;
    //     display: flex;
    //     flex-direction: column;
    //     align-items: flex-end;
    //     justify-content: flex-start;
    //     padding: 0;
    //     margin: 0;
    //     margin-left: auto;
    // }
    &__body {
      flex-direction: column;
    }

    &__right {
      padding: 30px 16px;
    }

    .order-item__flex {
      margin-right: 0;
    }

    &__cta {
      position: relative !important;
      right: 0;
      left: 0;
      top: 0;
      display: block;
      // max-width: 113px;
      // z-index: 4;

      .order-item__status {
        position: relative !important;
        top: unset;
        right: unset;
      }
    }

    &__title {
      font-size: 20px;
    }
  }

  .order-item {
    &__info {
      &_mml20 {
        margin-left: 20px !important;
      }
    }
  }
  .main-modal .modal-content {
    max-width: calc(100% - 150px) !important;
  }

  .order-modal__right {
    .order-item__status {
      font-size: 14px;
    }
  }
}

@media (max-width: 400px) {
  .main-modal .modal-content {
    max-width: calc(100% - 20px) !important;
    height: 80vh;
    overflow: scroll;
  }
}
</style>